import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import React from 'react';
import { registerMicroApps, start } from 'qiankun';
import './i18n';

const microApps = [
  {
    name: 'yunxiaozhi', // 云小智
    entry: import.meta.env.VITE_APP_ENTRY_YunXiaoZhi,
    container: '#subapp-viewport',
    activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/yunxiaozhi`,
    dsn: 'https://900d5b0070c74280a0ae6d541f3c3cbd@sentry.yunkecn.com/6',
  },
];
const { VITE_APP_PRIVATE } = import.meta.env;
if (VITE_APP_PRIVATE !== 'yunke' && VITE_APP_PRIVATE !== 'yongyou') { // 兼容私有部署 settings做为子应用加载
  microApps.push(...[
    {
      name: 'settings',
      entry: import.meta.env.VITE_APP_ENTRY_Settings,
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/settings`,
      dsn: 'https://8fdbadb7734d4d5c9833cd93da860383@sentry.yunkecn.com/7',
    },
  ]);
}
// 这几个只有yunke有
if (VITE_APP_PRIVATE === 'yunke' || VITE_APP_PRIVATE === 'yk2') {
  microApps.push(...[
    {
      name: 'letssell', // 商城 https://crm.yunkecn.com/cms/letssell/dashboard/platformdata
      entry: ['crm2.yunkecn.com'].includes(window.location.origin) ? import.meta.env.VITE_APP_ENTRY_Letssell : `${window.location.origin}/webback/`,
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/letssell`,
      dsn: 'https://2fa8fa79e7084304aa0fb87e3f40612b@sentry.yunkecn.com/9',
    },
    {
      name: 'scrm', // 企微 公众号 https://qw.yunkecn.com/
      entry: `${window.location.protocol}//${window.location.host.startsWith('test') || window.location.host.startsWith('qa') ? 'testqw' : 'qw'}${import.meta.env.VITE_APP_ENTRY_Scrm}`,
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/scrm`,
      dsn: 'https://086a6737449d459dba893cd1abebef8b@sentry.yunkecn.com/10',
    },
  ]);
}
if (VITE_APP_PRIVATE === 'xueqiu-beijing' || VITE_APP_PRIVATE === 'hongsong') {
  microApps.push(...[
    {
      name: 'enterpriseWeChat',
      entry: import.meta.env.VITE_APP_ENTRY_Qiyeweixin,
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/enterpriseWeChat`,
      dsn: 'https://873228f5a3a84ba59fb530c31058f3ed@sentry.yunkecn.com/8',
    },
  ]);
}
if (VITE_APP_PRIVATE === 'yongyou' || VITE_APP_PRIVATE === 'zhongfangxinfu') {
  const URL = {
    yunke: 'https://mochat-scrm.yunkecn.com',
    zhongfangxinfu: 'https://scrm.zfxf.com',
  };
  microApps.push(...[
    {
      name: 'mcrm',
      entry: URL[VITE_APP_PRIVATE] || import.meta.env.VITE_APP_ENTRY_MCRM,
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/mcrm`,
      dsn: 'https://086a6737449d459dba893cd1abebef8b@sentry.yunkecn.com/10',
    },
  ]);
}
if (VITE_APP_PRIVATE === 'zhongliang') {
  microApps.push(...[
    {
      name: 'mall',
      entry: import.meta.env.VITE_APP_ENTRY_Mall,
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/mall`,
      dsn: 'https://873228f5a3a84ba59fb530c31058f3ed@sentry.yunkecn.com/10',
    },
    {
      name: 'cofco',
      entry: JSON.parse(localStorage.getItem('companyInfo'))?.companyDomain ? `${JSON.parse(localStorage.getItem('companyInfo'))?.companyDomain}${JSON.parse(localStorage.getItem('companyInfo'))?.jumpPathInfo}` : '//localhost:3000',
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/cofco`,
      dsn: 'https://086a6737449d459dba893cd1abebef8b@sentry.yunkecn.com/10',
    },
  ]);
}
if (VITE_APP_PRIVATE === 'dongyi' || VITE_APP_PRIVATE === 'zhongliang') {
  microApps.push(...[
    {
      name: 'scrm',
      entry: VITE_APP_PRIVATE === 'dongyi' ? 'https://scrm.dyrs.com.cn' : 'https://core.cofco-capital.com',
      container: '#subapp-viewport',
      activeRule: `${import.meta.env.VITE_APP_ROOT_BASE}/scrm`,
      dsn: 'https://873228f5a3a84ba59fb530c31058f3ed@sentry.yunkecn.com/10',
    },
  ]);
}

window.React = React;
window.ReactDOM = ReactDOM;

const loadJs = () => {
  const isProduction = import.meta.env.MODE === 'production';
  const basePath = isProduction ? '/cms' : '';
  const scriptNc = document.createElement('script');
  scriptNc.src = `${basePath}/nc.js`;
  document.head.appendChild(scriptNc);
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://crm.yunkecn.com/yunkecom/yunkecom.min.js';
    script.onload = () => resolve(window.yunkecom);
    document.head.appendChild(script);
    // resolve();
  });
};
const loadApp = async () => {
  const { default: App } = await import('./App');
  return {
    App,
  };
};
loadJs().then(() => {
  loadApp().then(({ App }) => {
    ReactDOM.render(<App />, document.getElementById('root'));

    // 确保 DOM 完全加载后再注册和启动微应用
    setTimeout(() => {
      // 在 App 渲染完成后再注册 microApps
      registerMicroApps(microApps);

      // qiankun 通过fetch 请求百度地图 有跨域 问题 所以 过滤 百度地图使用 script 标签加载
      start({
        excludeAssetFilter: (url) => {
          const whiteWords = ['baidu', 'map', 'z_stat', 'weixin.qq.com', 'cnzz', 'wxLogin', '/State/query'];
          return whiteWords.some((w) => url.includes(w));
        },
      });
    }, 100);
  });
});

window.addEventListener('load', () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(`${window.location.origin}/cms/service-worker.js`);
  }
  if ('Notification' in window) {
    Notification.requestPermission();
  }
});
